
import { Injectable } from '@angular/core';
import { FormValuesService } from '../form-values/form-values.service';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';
import { Subject } from 'rxjs/Subject';

@Injectable()
export class ApiService {
  
  private requestAllSetDataArray : Array<any> = [];
  private requestAllGetPromises : Array<any> = [];
  
  private _calcNetto = new Subject<any>();
  calcNetto$ = this._calcNetto.asObservable();
  
  private nettoRequestObject = {
    "Person1":
      {
        "vorname":"Peter",
        "nachname":"Testkunde",
        "geburtsdatum":"01.01.1980",
        "bundesland":"Bayern",
        "berufsgruppe":1,
        "arbeitsstaetteOst":false,
        "steuerklasse":1,
        "kinderVorhanden":false,
        "kinderfreibetrag":0,
        "kstPflicht":true,
        "monatsbruttoentgelt":3000,
        "kvArt":1,
        "zusatzbeitragGkv":1.1,
        "monatsNettoentgelt":0
      },
    "Person2":null,
    "Settings":
      {
        "createCharts":false,
        "chartTheme":"default"
      }
  };

  constructor(
    private httpClient : HttpClient,
    private formValueService: FormValuesService,
  ){
    
  }

  private isRetina(){
    return ((window.matchMedia && (window.matchMedia('only screen and (min-resolution: 192dpi), only screen and (min-resolution: 2dppx), only screen and (min-resolution: 75.6dpcm)').matches || window.matchMedia('only screen and (-webkit-min-device-pixel-ratio: 2), only screen and (-o-min-device-pixel-ratio: 2/1), only screen and (min--moz-device-pixel-ratio: 2), only screen and (min-device-pixel-ratio: 2)').matches)) || (window.devicePixelRatio && window.devicePixelRatio >= 2)) && /(iPad|iPhone|iPod)/g.test(navigator.userAgent);
  }

  private doRequestAll(){

    let obs = this.httpClient.post(
      'https://api2.vorfina-it-service.de:8080/vorfinaApi/rest/TServerApi/calcVersorgung?tmp=' + Math.floor( Math.random() * 999999999 ),
      {
        "Person1": this.requestAllSetDataArray[0],
        "Person2": null,
        "Settings": {
          "createCharts" : false,
          "chartTheme" : "vf2d",
          "retina": this.isRetina(),
        }
      }
    );
    
    obs.subscribe( (response : any) => {

      this.formValueService.setValue( 'auswertung', JSON.stringify( response ) );
      this.requestAllSetDataArray.shift();

      if( this.requestAllSetDataArray.length ){
        window.setTimeout(() => {
          this.doRequestAll();
        }, 1);
      }else{
        let currentPromise : { resolve: (val) => {}, reject: (val) => {} };

        while( currentPromise = this.requestAllGetPromises.shift() ){
          currentPromise.resolve( response );
        }
      }
    }, ( error ) => {
      this.requestAllSetDataArray = [];
      let currentPromise : { resolve: (val) => {}, reject: (val) => {} };

      while( currentPromise = this.requestAllGetPromises.shift() ){
        currentPromise.reject( error );
      }
    });
  }
  
  public getVorsorge(){
    
  }

  public requestAll( person1 ){
    this.requestAllSet( person1 );
    return this.requestAllGet();
  }

  public requestAllSet( person1 ){
    this.requestAllSetDataArray.push( person1 );

    if( this.requestAllSetDataArray.length > 1 ){
      /* We will chain this without reordering.
       * Because it's enough of an implementation.
       */
      return;
    }

    this.doRequestAll();
  }  
  
  public requestAllGet(){
    if( this.requestAllSetDataArray.length ){
      let resolve;
      let reject;
      let prom = new Promise((g, b) => {resolve = g; reject = b;});

      this.requestAllGetPromises.push({resolve, reject});

      return prom;
    }else if( this.formValueService.hasValue( 'auswertung' ) ){
      return Promise.resolve( JSON.parse( this.formValueService.getValue( 'auswertung' ) ) );
    }else{
      return Promise.reject( 'No request has been made' );
    }
  }

  private getPersonFromResult( data, number ){
    return data['result'][0]['Person' + number];
  }

  private getSettingsFromResult( data ){
    return data['result'][0]['Settings'];
  }
  
  public getForm() {
   /* return this.httpClient.get(
      'https://service.versichern.online:8093/vorfinaApi/rest/TServerApi/getFormdataCapsulated'
    );
    */
  
    let formData = {"result":[{"Formdata":[
          {"uiType":"page","id":1,"displayText":"Pers\u00F6nliche Daten","items":[
            {"jsonName":"vorname","displayText":"Vorname","uiType":"text","requestType":"string","optional":true,"sampleValue":"Peter"},
            {"jsonName":"nachname","displayText":"Nachname","uiType":"text","requestType":"string","optional":true,"sampleValue":"Testkunde"},
          
            {
              "uiType":"row","rowId":"wqertz-3456-4205-ADA8-5EBAE6A5DFFA",
              "rowitems":[  
                {
                  "uiType": "col2",
                  "colId":"98765-234-asd2-sadd43-5EBAE7A5DFFA",
                  "displayText": "Geburtsdatum / Geschlecht",
                  "colitems": [
                    {"uiType":"row","rowId":"mbn6542-234sgdsd-420s5-ADA8-5EBAE7Ass9DFFA",
                      "rowitems":[
                        {"jsonName":"geburtsdatum","displayText":"Geburtsdatum", "displayTextPosition": "none", "uiType":"text","requestType":"string","optional":false,"sampleValue":"01.01.1980"},
                        {"jsonName":"geschlecht","displayText":"Geschlecht", "displayTextPosition": "none", "uiType":"selectfield","requestType":"integer","selectValues":["1","2"],"selectValuesDisplayText":["m\u00E4nnlich","weiblich"],"optional":true,"sampleValue":"1"},                 
                      ]
                    }
                  ]       
                }
              ]
            },
        
          {"jsonName":"bundesland","displayText":"Bundesland","uiType":"selectfield","requestType":"string","selectValues":["Baden-W\u00FCrttemberg","Bayern","Berlin","Brandenburg","Bremen","Hamburg","Hessen","Mecklenburg-Vorpommern","Niedersachsen","Nordrhein-Westfalen","Rheinland-Pfalz","Saarland","Sachsen","Sachsen-Anhalt","Schleswig-Holstein","Th\u00FCringen"],"selectValuesDisplayText":["Baden-W\u00FCrttemberg","Bayern","Berlin","Brandenburg","Bremen","Hamburg","Hessen","Mecklenburg-Vorpommern","Niedersachsen","Nordrhein-Westfalen","Rheinland-Pfalz","Saarland","Sachsen","Sachsen-Anhalt","Schleswig-Holstein","Th\u00FCringen"],"optional":false,"sampleValue":"Bayern"},{"jsonName":"berufsgruppe","displayText":"Berufsgruppe","uiType":"selectfield","requestType":"integer","selectValues":["1","2","3","4","5","6","7","8"],"selectValuesDisplayText":["Arbeitnehmer(in)","Arbeitnehmer(in) im \u00F6D","Beamter(-in)","Selbst\u00E4ndige(r)","Arbeitslose(r)","Hausfrau \/-mann","Sch\u00FCler(in) \/ Student(in)","Rentner(in)"],"optional":false,"sampleValue":"1"},{"jsonName":"arbeitsstaetteOst","displayText":"Arbeiten Sie in den neuen Bundesl\u00E4ndern?","uiType":"boolean","requestType":"boolean","optional":true,"sampleValue":"false"},{"jsonName":"steuerklasse","displayText":"Steuerklasse","uiType":"selectfield","requestType":"integer","selectValues":["1","2","3","4","5"],"selectValuesDisplayText":["1","2","3","4","5"],"optional":false,"sampleValue":"1"},{"jsonName":"kstPflicht","displayText":"Kirchensteuerpflicht","uiType":"boolean","requestType":"boolean","optional":false,"sampleValue":"true"},{"uiType":"row","rowId":"5AE3C69B-2B7B-4FFC-A442-4CADB9D48351","rowitems":[{"jsonName":"kinderVorhanden","displayText":"Haben Sie Kinder","uiType":"boolean","requestType":"boolean","optional":false,"sampleValue":"false","visibleControl":"kinderfreibetrag","visibleIfOperator":"0","visibleIfValue":"true"},
          {"jsonName":"kinderfreibetrag","displayText":"Kinderfreibetrag","uiType":"selectfield","requestType":"integer","selectValues":["0,0","0,5","1,0","1,5","2,0","2,5","3,0","3,5","4,0","4,5","5,0","5,5","6,0"],"selectValuesDisplayText":["0,0","0,5","1,0","1,5","2,0","2,5","3,0","3,5","4,0","4,5","5,0","5,5","6,0"],"optional":false,"sampleValue":"0,0"}]}]},
    
        {"uiType":"page","id":2,"displayText":"Finanzen","items":[{"jsonName":"monatsbruttoentgelt","displayText":"Monatsbruttoentgelt","uiType":"decimal","requestType":"decimal","optional":false,"sampleValue":"3000"},
              
          {
            "uiType":"row","rowId":"446D4BDA-01F7-4205-ADA8-5EBAE7A5DFFA",
            "rowitems":[  
              {
                "uiType": "col2",
                "colId":"446D4BDH-01F7-4205-ADA8-5EBAE7A5DFFA",
                "displayText": "davon",
                "colitems": [
                  {"uiType":"row","rowId":"446D4BDA-01F7-4205-ADA8-5EBAE7A9DFFA",
                    "rowitems":[
                      {
                        "jsonName": "bruttoRvPflichtig",
                        "displayText": "rv-pflichtig",
                        "uiType": "decimal",
                        "requestType": "decimal",
                        "optional": true,
                        "sampleValue": "3000", 
                        "displayTextPosition": "bottom",
                      },
                      {
                        "jsonName": "bruttoKvPflichtig",
                        "displayText": "kv-pflichtig",
                        "uiType": "decimal",
                        "requestType": "decimal",
                        "optional": true,
                        "sampleValue": "3000",
                        "displayTextPosition": "bottom",
                      },
                      {
                        "jsonName": "bruttoSteuerPflichtig",
                        "displayText": "steuerpflichtig",
                        "uiType": "decimal",
                        "requestType": "decimal",
                        "optional": true,
                        "sampleValue": "3000",
                        "displayTextPosition": "bottom" 
                      }
                    ]
                  }
                ]       
              }
            ]
          },
          
          {"jsonName":"rvPflichtig","displayText":"Sind Sie rentenversicherungspflichtig?","uiType":"boolean","requestType":"boolean","optional":false,"sampleValue":"true"},
          {"jsonName":"avPflichtig","displayText":"Sind sie arbeitslosenversicherungspflichtig?","uiType":"boolean","requestType":"boolean","optional":false,"sampleValue":"true"},
          {"jsonName":"kvArt","displayText":"Wie sind Sie krankenversichert?","uiType":"selectfield","requestType":"integer","selectValues":["1","2","3","4","5"],"selectValuesDisplayText":["gesetzlich pflichtversichert","gesetzlich freiwillig","gesetzlich mitversichert","privatversichert mit AG-Zuschuss","privatversichert ohne AG-Zuschuss"],"optional":false,"sampleValue":"false","visibleControl":"zusatzbeitragGkv|beitragPkv|beitragPkvAbsetzbar","visibleIfOperator":"1|2|2","visibleIfValue":"4|3|3"},
          {"jsonName":"zusatzbeitragGkv","displayText":"Zusatzbeitrag zur GKV","uiType":"decimal","requestType":"decimal","optional":false,"sampleValue":"1,1"},
          {"jsonName":"beitragPkv","displayText":"Monatsbeitrag zur PKV","uiType":"decimal","requestType":"decimal","optional":false,"sampleValue":"0"},
          {"jsonName":"beitragPkvAbsetzbar","displayText":"absetzbarer Anteil PKV-Beitrag","uiType":"decimal","requestType":"decimal","optional":false,"sampleValue":"0"},
          {"jsonName":"nettoeinkommen","displayText":"Durchschnittliches Nettoeinkommen", "uiType":"decimal","requestType":"decimal","optional":false,"sampleValue":"0"},
          {"jsonName":"versorgungszielEm","displayText":"Versorgungsziel bei EM \/ BU","uiType":"decimal","requestType":"decimal","optional":true,"sampleValue":"1650"},
          {
            "uiType":"row","rowId":"569AD8897-01F7-4205-A34DA8-9823745DFFA",
            "rowitems":[  
              {
                "uiType": "col2",
                "colId":"5432-01F7-420G5-ADA8-5EBADUH5DFFA",
                "displayText": "Wieviel Geld (in heutiger Kaufkraft) benötigen Sie monatlich bei:",
                "colitems": [
                  {"uiType":"row","rowId":"446D4BDA-3563-4205-ADA8-5EAJUE37A9DFFA",
                    "rowitems":[ 
                      {
                        "jsonName": "benEmBu",
                        "displayText": "EM/BU",
                        "uiType": "decimal",
                        "requestType": "decimal",
                        "optional": true,
                        "sampleValue": "1500", 
                        "displayTextPosition": "bottom",
                      },
                      {
                        "jsonName": "benAlter",
                        "displayText": "im Alter",
                        "uiType": "decimal",
                        "requestType": "decimal",
                        "optional": true,
                        "sampleValue": "1500",
                        "displayTextPosition": "bottom",
                      },
                    ]
                  }
                ]       
              }
            ]
          },
        ]},
          
        {"uiType":"page","id":3,"displayText":"Versorgung","items":[{"jsonName":"eintrittBerufsleben","displayText":"Eintritt ins Berufsleben (JJJJ)","uiType":"integer","requestType":"integer","optional":false,"sampleValue":"2000"},{"jsonName":"lueckenImVersicherungsverlauf","displayText":"L\u00FCcken im Versicherungsverlauf","uiType":"integer","requestType":"integer","optional":true,"sampleValue":"0"},{"jsonName":"anspruchGrvBekannt","displayText":"Kennen Sie Ihre Anspr\u00FCche aus der GRV","uiType":"boolean","requestType":"boolean","optional":false,"sampleValue":"false","visibleControl":"anspruchGrvRente|anspruchGrvEm","visibleIfOperator":"0|0","visibleIfValue":"true|true"},{"jsonName":"anspruchGrvRente","displayText":"Zur Regelrente","uiType":"decimal","requestType":"decimal","optional":false,"sampleValue":"0", "divider":"flip"},{"jsonName":"anspruchGrvEm","displayText":"Bei Erwerbsminderung","uiType":"decimal","requestType":"decimal","optional":false,"sampleValue":"0"}]},
        
        {"uiType":"page","id":4,"displayText":"Weiteres","items":[
          {
            "uiType":"row",
            "rowId":"123456B-01F7-ABC1-ADA8-5EBAE7A5DFFA",
            "rowitems":[  
              {
                "uiType": "col2",
                "colId":"AJHS3434-01F7-42344305-ADA8-5EBAE7A5DFFA",
                "displayText": "Wann möchten Sie in Rente gehen?",
                "colitems": [
                  {"uiType":"row","rowId":"sadsdsd-455454-478-ADA8-JJAZ6JA8",
                    "rowitems":[
                      {
                        "jsonName": "rentenBeginn",
                        "displayText": "Eintrittsalter",
                        "uiType": "integer",
                        "requestType": "integer",
                        "optional": false,
                        "sampleValue": "2050", 
                        "displayTextPosition": "bottom",
                      },
                    ]
                  }
                ]       
              }
            ]
          },
          {"jsonName":"inflation","displayText":"Angenommene durchschnittliche Inflation bis zum Rentenbeginn","uiType":"decimal","requestType":"decimal","optional":false,"sampleValue":"0"},
          {"jsonName":"zusatzVorsorge","displayText":"Haben Sie bereits zusätzliche Vorsorge getroffen?","uiType":"boolean","requestType":"boolean","optional":false,"sampleValue":"false","visibleControl":"zusatzVorsorgeButton","visibleIfOperator":"0","visibleIfValue":"true"},
          {
            "jsonName":             "zusatzVorsorgeButton",
            "uiType":               "modalButton",
            "requestType":          "string", 
            "divider":              "flip",
            "sampleValue":          "button",
            "optional":             false,
            "displayText":          "neue zusätzliche Vorsorge anlegen",
            "displayTextPosition":  "none",
            "executeId":             "123456B-ABCD-EFGH-ADA8-5EBAE7A5DFFA", 
          },           
          {
            "uiType":"modal",
            "modalId":"123456B-ABCD-EFGH-ADA8-5EBAE7A5DFFA", 
            "modalitems":[  
              {
                "jsonName":"absicherungArt",
                "displayText":"Art der Absicherung",
                "uiType":"selectfield",
                "requestType":"integer",
                "selectValues":["1"],
                "selectValuesDisplayText":[
                  "private Vorsorge",
                ],
                "optional":false,
                "sampleValue":"false",
                "visibleControl":"altersrente|unfallKapital|unfallAbsicherungMtl|emBuAbsicherung|hinterblKapital|hinterblRente",
                "visibleIfOperator":"0|0|0|0|0|0",
                "visibleIfValue":"1|1|1|1|1|1"
              },
              {"jsonName":"altersrente","displayText":"Altersrente","uiType":"decimal","requestType":"decimal","optional":false,"sampleValue":"1,1", "divider": "flip"},
              {"jsonName":"unfallKapital","displayText":"Unfall Kapital","uiType":"decimal","requestType":"decimal","optional":false,"sampleValue":"1,1"},
              {"jsonName":"unfallAbsicherungMtl","displayText":"Unfall Absicherung monatlich","uiType":"decimal","requestType":"decimal","optional":false,"sampleValue":"1,1"},
              {"jsonName":"emBuAbsicherung","displayText":"EM/BU Absicherung","uiType":"decimal","requestType":"decimal","optional":false,"sampleValue":"1,1"},
              {"jsonName":"hinterblKapital","displayText":"Hinterbliebenen Kapital","uiType":"decimal","requestType":"decimal","optional":false,"sampleValue":"1,1"},
              {"jsonName":"hinterblRente","displayText":"Hinterbliebenen Rente","uiType":"decimal","requestType":"decimal","optional":false,"sampleValue":"1,1"},
            ]
          },
        ]}
  
      ]}
    ]};
    
    const simpleObservable = new Observable((observer) => {  
      observer.next(formData)
      observer.complete()
    }) 
    return simpleObservable;
  }
  
  

  public getName(){
    return this.requestAllGet().then(( loadedData: any ) => {
      loadedData = this.getPersonFromResult(loadedData, 1);
      
      return {
        firstName : loadedData.vorname,
        lastName : loadedData.nachname,
      };
    });
  }

  public getUebersicht(){
    return this.requestAllGet().then(( loadedData: any ) => {
      loadedData = this.getPersonFromResult(loadedData, 1);
      
      return {
        inflationsrate              : loadedData.inflationsrate, // Inflation
        versorgungszielEm           : loadedData.versorgungszielEm, // Versorgungsziel EM/BU/Unfall
        versorgungszielAlter        : loadedData.versorgungszielAlter, // Versorgungsziel Alter
        lfzKrankheitsfall           : loadedData.lfzKrankheitsfall, // max Tage

        // krankengeld max 78 Wochen === konstant
        ergVersorgungszielKrankheit : loadedData.ergVersorgungszielKrankheit,  // Lohnfortzahlung
        ergKrankengeldKrankheit     : loadedData.ergKrankengeldKrankheit,  // Krankengeld
        
        // Berufsunfähigkeit?? 554 /1007?
        gewuenschterRentenbeginn    : loadedData.gewuenschterRentenbeginn, // mit xxx Jahren
        monatsNettoentgelt          : loadedData.monatsNettoentgelt,  // Altersrente
 
        ergDiagrammUebersicht       : loadedData.ergDiagrammUebersicht, // Diagramm
               
      };
    });
  }
  
  public getKrankheit(){
    return this.requestAllGet().then(( loadedData: any ) => {
      loadedData = this.getPersonFromResult(loadedData, 1);

      return {
        lfzKrankheitsfall                   : loadedData.lfzKrankheitsfall, // xx Tage volle Lohnfortzahlung
        ergVersorgungszielKrankheit         : loadedData.ergVersorgungszielKrankheit, // Versorgungsziel
        ergKrankengeldKrankheit             : loadedData.ergKrankengeldKrankheit, // Krankgengeld
        ergPrivatesKrankentagegeldKrankheit : loadedData.ergPrivatesKrankentagegeldKrankheit, // Privates Krankentagegeld
        ergBruttoversorgungKrankheit        : loadedData.ergBruttoversorgungKrankheit,  //Bruttoversorgung
        ergSteuernKrankheit                 : loadedData.ergSteuernKrankheit, // Steuern  
        ergSozialabgabenKrankheit           : loadedData.ergSozialabgabenKrankheit, // Sozialabgaben
        ergNettoversorgungKrankheit         : loadedData.ergNettoversorgungKrankheit, // Nettoversorgung
        ergVersorgungslueckeKrankheit       : loadedData.ergVersorgungslueckeKrankheit, // Versorgungslücke
        ergVersorgungslueckeTagKrankheit    : loadedData.ergVersorgungslueckeTagKrankheit, // täglicher Fehlbetrag
        ergDiagrammKrankheit                : loadedData.ergDiagrammKrankheit, // Diagramm
      };
    });
  }
  
  public getEmBu(){
    return this.requestAllGet().then(( loadedData: any ) => {
      loadedData = this.getPersonFromResult(loadedData, 1);

      return {
        restleistungsvermoegenGrv : loadedData.restleistungsvermoegenGrv, // Restleistungsvermögen in h
        versorgungszielEm         : loadedData.versorgungszielEm, // Versorgungsziel
        ergGesetzlichBruttoEm     : loadedData.ergGesetzlichBruttoEm, // Volle Erwerbsminderungsrente ???
        ergZusaetzlicheBruttoEm   : loadedData.ergZusaetzlicheBruttoEm, // zusätzliche Versorgung
        ergBruttoversorgungEm     : loadedData.ergBruttoversorgungEm, // Bruttoversorgung
        ergSteuernEm              : loadedData.ergSteuernEm, // Steuern
        ergSozialabgabenEm        : loadedData.ergSozialabgabenEm, // Sozialabgaben 
        ergNettoversorgungEm      : loadedData.ergNettoversorgungEm, // Nettoversorgung 
        ergVersorgungslueckeEm    : loadedData.ergVersorgungslueckeEm, // Versorgungslücke
        ergDiagrammEm             : loadedData.ergDiagrammEm, // Diagramm
      };
    });
  }
  
  public getUnfall(){
    return this.requestAllGet().then(( loadedData: any ) => {
      loadedData = this.getPersonFromResult(loadedData, 1);

      return {
        ergVersorgungszielUnfall    : loadedData.ergVersorgungszielUnfall, // Versorgungsziel
        ergVorhandenesKapitalUnfall : loadedData.ergVorhandenesKapitalUnfall, // Vorhandene Absicherung
        kapitalbedarfUnfall         : loadedData.kapitalbedarfUnfall, // Kapitalbedarf
        ergGesetzlichBruttoUnfall   : loadedData.ergGesetzlichBruttoUnfall, // Volle Erwerbsminderungsrente == Gesetzliche Versorgung ???
        ergZusaetzlicheBruttoUnfall : loadedData.ergZusaetzlicheBruttoUnfall, // zusätzliche Versorgung
        ergBruttoversorgungUnfall   : loadedData.ergBruttoversorgungUnfall, // Brutto-Versorgung
        ergSteuernUnfall            : loadedData.ergSteuernUnfall, // Steuern 
        ergSozialabgabenUnfall      : loadedData.ergSozialabgabenUnfall, // Sozialabgaben
        ergNettoversorgungUnfall    : loadedData.ergNettoversorgungUnfall, // Netto-Versorgung
        ergVersorgungslueckeUnfall  : loadedData.ergVersorgungslueckeUnfall, // Versorgungslücke
        ergDiagrammUnfallkapital    : loadedData.ergDiagrammUnfallkapital, // Diagramm
        ergDiagrammUnfallrente      : loadedData.ergDiagrammUnfallrente // Diagramm 2 ??
      };
    });
  }
  
  public getAlter(){
    return this.requestAllGet().then(( loadedData: any ) => {
      loadedData = this.getPersonFromResult(loadedData, 1);

      return {
        inflationsrate            : loadedData.inflationsrate, // Inflation
        ergVersorgungszielAv      : loadedData.ergVersorgungszielAv, // Versorgungsziel  
        ergGesetzlichBruttoAv     : loadedData.ergGesetzlichBruttoAv, // Gesetzliche Rente
        ergZusaetzlicheBruttoAv   : loadedData.ergZusaetzlicheBruttoAv, // zusätzliche Versorgung
        ergBruttoversorgungAv     : loadedData.ergBruttoversorgungAv, // Bruttoversorgung 
        ergSteuernAv              : loadedData.ergSteuernAv, // Steuern
        ergSozialabgabenAv        : loadedData.ergSozialabgabenAv, // Sozialabgaben
        ergNettoversorgungAv      : loadedData.ergNettoversorgungAv, // Nettoversorgung
        ergVersorgungslueckeAvInf : loadedData.ergVersorgungslueckeAvInf, // Versorgungslücke
        ergDiagrammAv             : loadedData.ergDiagrammAv, // Diagramm
      };
    });
  }
   
  public getPflege(){
    return this.requestAllGet().then(( loadedData: any ) => {
      loadedData = this.getPersonFromResult(loadedData, 1);

      return {
        ergVersorgungslueckeAv : loadedData.ergVersorgungslueckeAv, // Versorgungsziel            
      };
    });
  }  
  
  public getModalContentPlaceholder(){
    return Promise.resolve( 
      [
        { 
          name: "Private Vorsorge",
          image: "assets/img/versicherungen/hdi.png", 
          nr: "ABCD-12345-12-123456",
          date: "01.09.2027",
          contribution: 444.44,
        },
        { 
          name: "Pflegeversicherung",
          image: "assets/img/versicherungen/allianz.png", 
          nr: "XYZ-54321-12-123456",
          date: "11.11.2044",
          contribution: 888.44,
        }  
      ] 
    );
  }
  
  public emitNettoValues(){
    let good, bad;
    let promise = new Promise( ( g, b ) => { good = g; bad = b; } );

    let finishFunc = (( len ) => {
      return () => {
        --len;
        if( !len ){
          good();
        } 
      };
    })( this._calcNetto.observers.length );
    
    this._calcNetto.next( finishFunc );
    return promise;
  }
  
  public setNettoValues(requestObj){
    let requestKeys = Object.keys(requestObj);
    let nettoKeys   = Object.keys(this.nettoRequestObject.Person1);
    
    let matchingKeys = [];
    for(let i in requestKeys) {   
      if(nettoKeys.indexOf(requestKeys[i]) > -1){
        matchingKeys.push(requestKeys[i]);
      }
    }
    
    matchingKeys.forEach(key => {
      this.nettoRequestObject.Person1[key] = requestObj[key];
      if (this.nettoRequestObject.Person1[key].day){
        let date = Object.assign({}, this.nettoRequestObject.Person1[key]);
        this.nettoRequestObject.Person1[key] = date.day + "." + date.month  + "." +  date.year;
      }
    });
  }
  
  private getNettoObs = new Subject<any>();
  getNettoObs$ = this.getNettoObs.asObservable();
  
  public nettoObs(){
    return this.getNettoObs$;
  }
  
  public getNettoValues(){ 
    this.nettoRequestObject.Person1.berufsgruppe = 1;
    
    let obs = this.httpClient.post( 'https://api1.vorfina-it-service.de:8080/vorfinaApi/rest/TServerApi/calcNettoentgelt', this.nettoRequestObject );
    this.getNettoObs.next(obs.toPromise());
    return obs.toPromise();
  }
  
  public getCustomerIds(){
    let obs = this.httpClient.post( 'https://api1.vorfina-it-service.de:8080/vorfinaApi/rest/TServerApi/getDatensaetze', {});
    
    return obs.toPromise();
  }
  
  public getCustomerDetails(idObj){
    let obs = this.httpClient.post( 'https://api1.vorfina-it-service.de:8080/vorfinaApi/rest/TServerApi/getDatensatzIntro', idObj);
    
    return obs.toPromise();
  }
  
  public getCustomerShortList () {
    let obs = this.httpClient.post( 'https://api2.vorfina-it-service.de:8080/vorfinaApi/rest/TServerApi/getDatensaetzeShortList', {});
    return obs;
  }
   
}


// WEBPACK FOOTER //
// ./src/app/services/api/api.service.ts